import {Component, Input} from '@angular/core';
import {FormGroup} from "@angular/forms";

@Component({
  selector: 'field-relation-single',
  templateUrl: 'field-relation-single.component.html',
  styleUrls: ['field-relation-single.component.scss']
})
export class FieldRelationSingleComponent {
  @Input() field!: any;
  @Input() formGroup!: FormGroup;

  constructor() {
  }

  ngOnInit() {

  }


}
